const DOB_FIELD_TOKENS = ['dob', 'date_of_birth', 'birth_date', 'birthdate'];

const buildFieldMatcher = (tokens) => (field) => {
  const fieldName = (field?.internal_name || '').toLowerCase();
  if (!fieldName) {
    return false;
  }
  return tokens.some((token) => fieldName.includes(token));
};

const coalescePatientValue = (patient, keys = []) => {
  if (!patient) {
    return undefined;
  }

  return [patient.metadata, patient].reduce((matchedValue, source) => {
    if (matchedValue !== undefined) {
      return matchedValue;
    }
    if (!source) {
      return undefined;
    }

    const matchedKey = keys.find((key) => {
      const value = source?.[key];
      return value !== undefined && value !== null && value !== '';
    });

    return matchedKey ? source[matchedKey] : undefined;
  }, undefined);
};

const matchesDobField = buildFieldMatcher(DOB_FIELD_TOKENS);

const extractPatientDob = (patient) => (
  coalescePatientValue(patient, [
    'date_of_birth',
    'dateOfBirth',
    'dob',
    'birth_date',
    'birthDate',
    'patientDateOfBirth',
  ])
);

const extractPatientMrn = (patient) => (
  coalescePatientValue(patient, [
    'mrn',
    'MRN',
    'medical_record_number',
    'medicalRecordNumber',
  ])
);

const derivePatientIdentifierDisplay = (patientId, mrnValue) => {
  const normalizedMrn = typeof mrnValue === 'string' ? mrnValue.trim() : mrnValue;
  if (normalizedMrn !== undefined && normalizedMrn !== null && normalizedMrn !== '') {
    return String(normalizedMrn);
  }

  if (patientId === undefined || patientId === null) {
    return patientId;
  }

  const normalizedId = typeof patientId === 'string' ? patientId.trim() : patientId;
  if (normalizedId === '') {
    return normalizedId;
  }

  return String(normalizedId);
};

const getSectionIconType = (sectionTitle) => {
  const title = (sectionTitle || '').toLowerCase();
  if (title.includes('patient')) {
    return 'patient';
  }
  if (title.includes('document') || title.includes('file')) {
    return 'document';
  }
  if (title.includes('folder') || title.includes('category')) {
    return 'folder';
  }
  return 'list';
};

const getWorkflowIconType = (workflow, title) => {
  const workflowLower = (workflow || '').toLowerCase();
  const titleLower = (title || '').toLowerCase();

  if (workflowLower.includes('task') || titleLower.includes('task')) {
    return 'task';
  }
  if (workflowLower.includes('create') || titleLower.includes('create')) {
    return 'create';
  }
  return 'send';
};

export {
  buildFieldMatcher,
  coalescePatientValue,
  derivePatientIdentifierDisplay,
  extractPatientDob,
  extractPatientMrn,
  getSectionIconType,
  getWorkflowIconType,
  matchesDobField,
};
